import { Client } from "./_clientService";

async function getBanners(options: any) {
  try {
    let payload = {
      pageNo: options?.pageNo,
      limit: options?.pageSize,
      sortKey: "createdAt",
      sortDir: "ASC",
      search: options?.search,
      skipPagination: options?.skipPagination ?? false,
    };
    let path = "/banner/list";
    const resp = await new Client({ path, payload }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

async function getBannerInfo(bannerId: any) {
  try {
    const resp = await new Client({
      path: "/banner/info",
      payload: {
        bannerId: bannerId,
      },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createBanner(bannerDetails: any) {
  try {
    const resp = await new Client({
      path: "/banner/create",
      payload: bannerDetails,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateBanner(bannerDetails: any, bannerId: any) {
  try {
    const resp = await new Client({
      path: "/banner/update",
      payload: { ...bannerDetails, _id: bannerId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function deleteBanner(bannerId: any) {
  const resp = await new Client({
    path: "banner/delete",
    payload: { bannerId },
  }).post();

  return resp;
}

export async function updateBannerStatus(bannerId: any) {
  const resp = await new Client({
    path: "/banner/update/status",
    payload: { bannerId },
  }).patch();

  return resp;
}

export { getBanners, getBannerInfo, createBanner, updateBanner };
